import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Image from "next/image";
import { memo } from "react";
export const NoTranscript = /*#__PURE__*/ memo(()=>{
    return /*#__PURE__*/ _jsxs("div", {
        className: "flex grow flex-col items-center gap-4 py-4",
        children: [
            /*#__PURE__*/ _jsx(Image, {
                alt: "Illustration of no transcript",
                width: 150,
                height: 150,
                src: "/assets/illustrations/cat-in-box.svg"
            }),
            /*#__PURE__*/ _jsx("div", {
                className: "text-center text-12 text-grey-11",
                children: "No transcript was detected in this file"
            })
        ]
    });
});
NoTranscript.displayName = "NoTranscript";
